import { TranslationKeys } from '@I18n/types';

export function makeChoices<T>(
  choicesMap: {
    [key in T extends string ? T : 'missing type']: TranslationKeys;
  },
): Array<{
  id: T;
  name: TranslationKeys;
}> {
  return Object.entries(choicesMap).map(([key, value]) => ({
    id: key as T,
    name: value as TranslationKeys,
  }));
}
